import { Service } from '@angular/core';
import { Branch } from '@portal-core/branches/models/branch.model';
import { BranchesState } from '@portal-core/branches/services/branches-data.service';
import { PageDataServiceBase, PageState, PageStateBase, PageStateService } from '@portal-core/data/page/services/page.state';

@PageState({
  name: 'projectBranchesPageState',
  actionName: 'ProjectBranchesPage'
})
export class ProjectBranchesPageState extends PageStateBase { }

@Service()
@PageStateService<Branch>({
  pageState: ProjectBranchesPageState,
  itemCollectionState: BranchesState
})

export class ProjectBranchesPageDataService extends PageDataServiceBase<Branch> {
  override state = ProjectBranchesPageState;
}
